// extracted by mini-css-extract-plugin
export default {"picSlider":"picSlider__1D7bO","teamText":"teamText__exICf"};